import { CONNECT_TO_EXTERNAL_API } from '@m/constants/FeatureFlags';
import { setDefaultAuthMethod } from '@m/utils/http';
import Providers from 'providers';

import Customer from './Customer';
import { CustomerGlobalStyle } from './CustomerApp.styled';

if (CONNECT_TO_EXTERNAL_API) setDefaultAuthMethod('token');

export default function App() {
  return (
    <Providers>
      <CustomerGlobalStyle />
      <Customer />
    </Providers>
  );
}
